import { FeatureFlags } from "../constants/LocalServerConstants";

export const BPQuestionLabels = {
  PurchaseRefinanceOptionLookupId: `Will the property be purchased, refinanced or is it owned ${FeatureFlags.IS_UNIT_PROPERTY_REDESIGN ? "free and clear" : "outright"}?`,
  TransactionType: "Is it an external or internal refinance?",
  EstimatePropertyValue: "What is the estimated current value of the property?",
  Purchase_OriginalPurchasePrice: "What is the purchase price?",
  RefinanceOwn_OriginalPurchasePrice: "What was the original purchase price?",
  AmountOwed: "What is the estimated payoff?",
  DurationOwnedId: "How long has the Borrowing Entity owned the property?",
  CashOutAmountRequested: "What is the expected cash back at closing, if any?",
  RefinanceInternalDescription: "Loan is already managed with this lender",
  RefinanceExternalDescription: "Lender will need to refinance the debt",
  AfterRepairValue: "What will be the total finished lot value after horizontal work is complete?",
  Zoning: "What is the current zoning of the property?",
  EstimatedSalesPrice: "Stabilized Value (ARV)",
  WorkStage: "What is the estimated percent of work complete on the project?",
  NewStructure: "What type of structure(s) will be built?",
  BrokerFeeRate: "What is the standard broker fee?",
  BrokerFeeRateRebate: "What is the broker fee above the lender paid rebate?",
  CombineOriginationFeeRate: "Do you want to roll the broker fee into the origination fee",
  WlBrokerFeeRate: "What is the whitelabeled broker fee?",
  MinMandatoryBrokerFeeRate: "Minimum mandatory broker fee",
  TotalBrokerFeeRate: "Total broker fee",
  DistrictReimbursements: "Are there district reimbursements available?",
  BondingRequirements: "Are there bonding requirements?",
  SeasonalityConcerns: "Are there seasonality concerns?",
  BrokerAssociated: "Is a broker associated with this loan?",
  LoanOfficer: "Who is the loan officer?",
  PermitStatus: "What is the permit status?",
  PermitStatusCurrent: "What is the current permit status?",
  AdditionalDetailsPermitStatus: "Additional details regarding permit status",
  SizeOfCurrentProperty: "What is the size of the current property?",
  SizeOfProposedLots: "What is the size of the proposed lots?",
  BorrowingEntity: "Who is the Borrowing Entity?"
};